import CryptoJS from "crypto-js";

export function decryptPayload(urlSafeToken, secretKey) {
  try {
    let cleanToken = urlSafeToken.replace(/["'\s]/g, "");
    let base64 = cleanToken.replace(/-/g, "+").replace(/_/g, "/");
    const pad = base64.length % 4;
    if (pad) base64 += "=".repeat(4 - pad);

    const ciphertext = CryptoJS.enc.Base64.parse(base64);

    const passphraseBytes = CryptoJS.enc.Utf8.parse(secretKey);
    const hash = CryptoJS.SHA256(passphraseBytes);
    const derivedKey = CryptoJS.lib.WordArray.create(
      hash.words.slice(0, 4),
      16
    );

    const decrypted = CryptoJS.AES.decrypt({ ciphertext }, derivedKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    const jsonString = decrypted.toString(CryptoJS.enc.Utf8);

    if (!jsonString) throw new Error("Decryption failed. Output is empty.");
    return JSON.parse(jsonString);
  } catch (error) {
    console.error("Token decryption failed:", error);
    throw new Error("INVALID_TOKEN");
  }
}
